import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Big moves dim the world, frame it in letterbox bars and stamp their glyph across the screen. */
    cinematic: boolean;
  }
}

defineSetting({
  key: 'cinematic',
  default: true,
  order: 70,
  menu: { group: 'visual', label: 'ฉากท่าใหญ่ (ฉากมืด แถบภาพยนตร์ ตราอักษร)' },
});
